var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "column content page",
    attrs: {
      "id": "more-page"
    }
  }, [_c('h1', [_vm._v("MORE")]), _vm._v(" "), _c('div', {
    staticClass: "block",
    attrs: {
      "id": "past-products"
    }
  }, [_c('h2', [_vm._v("READY MADE GO PAST")]), _vm._v(" "), _c('p', [_vm._v("Ready Made Go is an ongoing project. So far, eighteen designs have been made by seventeen different London-based designers and design groups since 2015. All of those objects can be seen in use today in the hotel interior. The objects range from small items, like a door handle, to large installations, like the gymnasium climbing wall. Here are previously launched items to look out for:")]), _vm._v(" "), _c('p', [_vm._v("Spin copper ashtray "), _c('br'), _vm._v("\n      by Tomás Alonso")]), _vm._v(" "), _c('p', [_vm._v("BBQ ceramic tiles "), _c('br'), _vm._v("\n      by Assemble")]), _vm._v(" "), _c('p', [_vm._v("Mono sunglasses "), _c('br'), _vm._v("\n      by Parsha Gerayesh")]), _vm._v(" "), _c('p', [_vm._v("The Erosianal Remnant sculpture "), _c('br'), _vm._v("\n      by Hilda Hellström")]), _vm._v(" "), _c('p', [_vm._v("Amorph drinking glasses "), _c('br'), _vm._v("\n      by Jochen Holz")]), _vm._v(" "), _c('p', [_vm._v("Ace stacking stool "), _c('br'), _vm._v("\n      by Philippe Malouin")]), _vm._v(" "), _c('p', [_vm._v("Hex door handle "), _c('br'), _vm._v("\n      by Philippe Malouin")]), _vm._v(" "), _c('p', [_vm._v("Ascension bouldering wall "), _c('br'), _vm._v("\n      by Patternity")]), _vm._v(" "), _c('p', [_vm._v("Here & There signage "), _c('br'), _vm._v("\n      by Kellenberger White")]), _vm._v(" "), _c('p', [_vm._v("Botanic Jewellery "), _c('br'), _vm._v("\n      by Marcin Rusak")]), _vm._v(" "), _c('p', [_vm._v("Beam soap dishes "), _c('br'), _vm._v("\n      by Silo Studio")]), _vm._v(" "), _c('p', [_vm._v("The Doublet quilt "), _c('br'), _vm._v("\n      by Toogood")]), _vm._v(" "), _c('p', [_vm._v("Cast lights "), _c('br'), _vm._v("\n      by Studio Vit")])]), _vm._v(" "), _c('div', {
    staticClass: "block",
    attrs: {
      "id": "contacts"
    }
  }, [_c('h2', [_vm._v("CONTACTS")]), _vm._v(" "), _c('p', [_vm._v("Ready Made Go 3"), _c('br'), _vm._v("\n      20–24 September 2017"), _c('br'), _vm._v("\n      Ace Hotel London"), _c('br'), _vm._v("\n      100 Shoreditch High Street")]), _vm._v(" "), _c('p', [_vm._v("For further information or imagery, please contact:"), _c('br'), _vm._v("\n      Camron PR"), _c('br'), _vm._v("\n      +44 (0)20 7240 1700"), _c('br'), _vm._v("\n      Sarah Ferrall"), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:sarah.ferrall@camronpr.com"
    }
  }, [_vm._v("sarah.ferrall@camronpr.com")]), _c('br'), _vm._v("\n      Kerry Lynch"), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:kerry.lynch@camronpr.com"
    }
  }, [_vm._v("kerry.lynch@camronpr.com")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "href": "https://www.dropbox.com/sh/ba9p70zi926i520/AACFudgTECEEtyKVthd5A49Ha?dl=0",
      "target": "_blank"
    }
  }, [_vm._v("IMAGE & MEDIA KIT")])]), _vm._v(" "), _c('div', {
    staticClass: "block",
    attrs: {
      "id": "modern-design-review"
    }
  }, [_c('h2', [_vm._v("MODERN DESIGN REVIEW")]), _vm._v(" "), _c('p', [_vm._v("Modern Design Review is an international, independent, magazine that covers the best of the product, people and theory at the effervescent tip of contemporary design. The London-based publication offers a considered and curated insight into modern design through original and creative storytelling and contributions from talented photographers, writers and designers.")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "http://www.moderndesignreview.com",
      "target": "_blank"
    }
  }, [_vm._v("moderndesignreview.com")]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://instagram.com/modern_design_review",
      "target": "_blank"
    }
  }, [_vm._v("@modern_design_review")]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://twitter.com/mdreview14",
      "target": "_blank"
    }
  }, [_vm._v("@MDREVIEW14")])])]), _vm._v(" "), _c('div', {
    staticClass: "block",
    attrs: {
      "id": "ace-hotel-london"
    }
  }, [_c('h2', [_vm._v("ACE HOTEL LONDON")]), _vm._v(" "), _c('p', [_vm._v("Ace Hotel London hangs its hat in London's most creative and engaged district – a focus for culture, home of the world famous open-air market on Brick Lane and a canvas for street artists the world over. The neighbourhood's legacy includes theatres running banned 16th century plays, the debut of drag pioneer Hetty King and the first rumbles of industrialized craft in the Western Hemisphere. Today's Shoreditch is a leader in art, design, cuisine, culture and technology – an outpost in the global community of ideas.")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "http://www.acehotel.com/london",
      "target": "_blank"
    }
  }, [_vm._v("acehotel.com/london")]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://instagram.com/acehotel",
      "target": "_blank"
    }
  }, [_vm._v("@acehotel")])])]), _vm._v(" "), _c('div', {
    staticClass: "block",
    attrs: {
      "id": "credits"
    }
  }, [_c('h2', [_vm._v("CREDITS")]), _vm._v(" "), _c('p', [_vm._v("Identity, exhibition design and website design by Daly & Lyon"), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.daly-lyon.co.uk",
      "target": "_blank"
    }
  }, [_vm._v("daly-lyon.co.uk")]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://instagram.com/daly_lyon",
      "target": "_blank"
    }
  }, [_vm._v("@daly_lyon")])]), _vm._v(" "), _c('p', [_vm._v("Website development by "), _c('a', {
    attrs: {
      "href": "http://atelierace.com",
      "target": "_blank"
    }
  }, [_vm._v("Atelier Ace")]), _vm._v(".")]), _vm._v(" "), _c('p', [_vm._v("Making photography by:"), _c('br'), _vm._v("\n      Peter Guenzel (Michael Marriott Totem Stool)"), _c('br'), _vm._v("\n      Jorn Tomter (All other making photography)"), _c('br'), _vm._v("\n      Nicholas Gardner and Alasdair Bremner (Additional Finger Table photography)")]), _vm._v(" "), _c('p', [_vm._v("Still life photography by:"), _c('br'), _vm._v("\n      Ansgar Sollmann")]), _vm._v(" "), _c('p', [_vm._v("Finger Tables kindly sponsored by Alusid"), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.alusid.co.uk",
      "target": "_blank"
    }
  }, [_vm._v("alusid.co.uk")]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://instagram.com/alusiduk",
      "target": "_blank"
    }
  }, [_vm._v("@alusiduk")])]), _vm._v(" "), _c('p', [_vm._v("Special thanks to "), _c('a', {
    attrs: {
      "href": "http://www.smileplastics.com",
      "target": "_blank"
    }
  }, [_vm._v("Smile Plastics")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "http://www.veolia.co.uk",
      "target": "_blank"
    }
  }, [_vm._v("Veolia")]), _vm._v(".")])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-634add45","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MorePage.vue
// module id = iM9H
// module chunks = 1